var _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInAndOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 164,
    viewBox: "0 0 126 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.6633,
    y: 17.6438,
    width: 37.5779,
    height: 128.712,
    rx: 4.7,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6633,
    y: 17.6438,
    width: 37.5779,
    height: 125.484,
    rx: 4.2,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8797,
    y: 18.9383,
    width: 35.1449,
    height: 122.897,
    rx: 3.4,
    fill: "white",
    stroke: "#C6C3C3",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.34 111.311H88.5965C87.1452 111.311 85.9688 112.347 85.9688 113.627C85.9688 114.906 87.1452 115.943 88.5965 115.943H93.34V111.311Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 17.6438,
    width: 16.6641,
    height: 64.0561,
    rx: 2.7,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2703,
    y: 18.534,
    width: 14.72,
    height: 62.2762,
    rx: 2.2,
    fill: "white",
    stroke: "#C6C3C3",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0511 48.3027H45.0666C43.8476 48.3027 42.8594 49.2193 42.8594 50.3499C42.8594 51.4806 43.8476 52.3971 45.0666 52.3971H49.0511V48.3027Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAndOut);
export default __webpack_public_path__ + "static/media/in-and-out.b59b02778226f8b45238afa31169b730.svg";
export { ForwardRef as ReactComponent };